/**
 * 接口配置
 */
// 默认生产环境配置
let IC_HOST = "https://boundary.ic0.app";
let IDENTITY_PROVIDER = "https://identity.ic0.app/";
let LEDGER_CANISTER_ID = "ryjl3-tyaaa-aaaaa-aaaba-cai";
let LAUNCHPAD_CANISTER_ID = "pczmq-maaaa-aaaah-abhwa-cai";
let SHIKU_CANISTER_ID = "udtw4-baaaa-aaaah-abc3q-cai";
let RECORD_CANISTER_ID = "uesqi-myaaa-aaaah-abc3a-cai";
let POINT_CANISTER_ID = "qqamp-7iaaa-aaaah-qakha-cai";
let APPLY_CANISTER_ID = "cxgiz-nyaaa-aaaah-abg6q-cai";
let OAT_CANISTER_ID = "v43fl-cyaaa-aaaah-abc7a-cai";
let ARTIST_ROUTER_CANISTER_ID = "qnblj-lyaaa-aaaah-aa74a-cai";
let NEW_RECORD_CANISTER_ID = "56www-tyaaa-aaaap-aai4q-cai";
let ORIGYN_YUMI_CANISTER_ID = "od7d3-vaaaa-aaaap-aamfq-cai";
let OGY_LEDGER_CANISTER_ID = "ryjl3-tyaaa-aaaaa-aaaba-cai";
let AWS_HOST = "https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com";
let API_URL = "https://api.yumi.io/api";
let LANDS_CANISTER_ID = "3j32q-6iaaa-aaaap-aaijq-cai";
let chain = {
  Ethereum: ["0x1", "https://mainnet.infura.io/v3/"],
  "BNB Chain": ['0x38', "https://bsc-dataseed.binance.org/"],
  Polygon: ['0x89', "https://polygon-mainnet.infura.io"]
}

let GALLERY_CANISTER_ID = 'rapph-eqaaa-aaaah-aa73q-cai';
let CCC_PROXY_CANISTER_ID = 'owefd-waaaa-aaaah-abu2q-cai'
// 测试环境
if (process.env.NODE_ENV === "development") {
  chain = {
    Ethereum: ["0xaa36a7", "https://sepolia.infura.io/v3/591fdcdc47364505b1eec45f85b4d1fc"],
    "BNB Chain": ['0x61', "https://data-seed-prebsc-1-s1.binance.org:8545"],
    Polygon: ['0x13881', "https://matic-mumbai.chainstacklabs.com"]
  }
  LEDGER_CANISTER_ID = "irzpe-yqaaa-aaaah-abhfa-cai";
  LAUNCHPAD_CANISTER_ID = "o2qzt-caaaa-aaaah-abhsa-cai";
  POINT_CANISTER_ID = "l2pzh-6iaaa-aaaah-abhpq-cai";
  SHIKU_CANISTER_ID = "ajy76-hiaaa-aaaah-aa3mq-cai";
  RECORD_CANISTER_ID = "zf7n3-2aaaa-aaaah-aanea-cai";
  LANDS_CANISTER_ID = "3j32q-6iaaa-aaaap-aaijq-cai";
  APPLY_CANISTER_ID = "qhbz2-eiaaa-aaaah-abcaa-cai";
  OAT_CANISTER_ID = "xlsz5-7aaaa-aaaah-abfma-cai";
  ARTIST_ROUTER_CANISTER_ID = "v32d7-paaaa-aaaah-abc7q-cai";
  NEW_RECORD_CANISTER_ID = "sgynd-aaaaa-aaaah-abcnq-cai";
  GALLERY_CANISTER_ID = "rapph-eqaaa-aaaah-aa73q-cai";
  ORIGYN_YUMI_CANISTER_ID = "patk5-byaaa-aaaap-aamda-cai";
  OGY_LEDGER_CANISTER_ID = "irzpe-yqaaa-aaaah-abhfa-cai";
  AWS_HOST = "https://yumi-frontend-assets-dev.s3.ap-east-1.amazonaws.com";
  API_URL = "http://18.167.36.15:5000/api";
  CCC_PROXY_CANISTER_ID = 'tut64-gqaaa-aaaah-ab2qq-cai'
}
// 预发布环境
if (process.env.NODE_ENV === "stage") {
  LEDGER_CANISTER_ID = "ryjl3-tyaaa-aaaaa-aaaba-cai";
  LAUNCHPAD_CANISTER_ID = "4aatc-iyaaa-aaaao-aabsa-cai";
  POINT_CANISTER_ID = "k52eo-fyaaa-aaaag-qagha-cai";
  SHIKU_CANISTER_ID = "pfsjt-fqaaa-aaaap-aaapq-cai";
  RECORD_CANISTER_ID = "kuzps-tqaaa-aaaag-qaggq-cai";
  LANDS_CANISTER_ID = "3j32q-6iaaa-aaaap-aaijq-cai";
  OAT_CANISTER_ID = "xbgld-rqaaa-aaaah-abcqq-cai";
  ARTIST_ROUTER_CANISTER_ID = "st74o-biaaa-aaaah-abcoa-cai";
  GALLERY_CANISTER_ID = "rapph-eqaaa-aaaah-aa73q-cai";
  NEW_RECORD_CANISTER_ID = "d4uvm-2iaaa-aaaap-aakrq-cai";
  ORIGYN_YUMI_CANISTER_ID = "owysw-uiaaa-aaaap-aamga-cai";
  OGY_LEDGER_CANISTER_ID = "ryjl3-tyaaa-aaaaa-aaaba-cai";
  AWS_HOST = "https://storageapi.fleek.co/2c3922ff-7211-45da-bb7a-56d1c6fbc3c0-bucket";
  API_URL = "http://18.167.36.15:4000/api";
  CCC_PROXY_CANISTER_ID = 'porhv-2iaaa-aaaap-aamca-cai'
}

export {
  IC_HOST,
  IDENTITY_PROVIDER,
  LEDGER_CANISTER_ID,
  LAUNCHPAD_CANISTER_ID,
  POINT_CANISTER_ID,
  SHIKU_CANISTER_ID,
  RECORD_CANISTER_ID,
  APPLY_CANISTER_ID,
  OAT_CANISTER_ID,
  ARTIST_ROUTER_CANISTER_ID,
  NEW_RECORD_CANISTER_ID,
  ORIGYN_YUMI_CANISTER_ID,
  OGY_LEDGER_CANISTER_ID,
  GALLERY_CANISTER_ID,
  AWS_HOST,
  API_URL,
  chain,
  LANDS_CANISTER_ID,
  CCC_PROXY_CANISTER_ID,
};
